export default {
  produtos: [],
};
